import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import * as queryString from 'query-string'

import { ButtonControl } from '../../components/common'
import { VoteCard } from '../../components/prediction'
import { Slider, Rating } from '../../components/home'

import {
	getUserId,
	setFlowType,
	setImage,
	getFlowTag,
	getIsLegalFlow,
	getCountryCode,
} from '../../redux/slices/userSlice'
import {
	ampEvent,
	ampEventWithEventProperty,
	ampSetUserProperty,
} from '../../utils/amplitude'
import { applyCartoonifyFilter } from '../../utils/cartoonifyFilter'
import { paramsToQuery } from '../../utils/historyDecorators'
import { setSecondFlow, setThirdFlow } from '../../redux/slices/questionsSlice'

import './styles.scss'
import { getInitialPrice, getUpsellPrice } from '../../redux/slices/configSlice'

const HomeScreen = () => {
	const dispatch = useDispatch()
	const history = useHistory()
	const params = queryString.parse(location.search)

	const flow_tag = useSelector(getFlowTag)
	const isLegalFlow = useSelector(getIsLegalFlow)

	const [isUploadPhotoActive, setIsUploadPhotoActive] = useState(false)
	const [isActive, setIsActive] = useState(false)
	const user_id = useSelector(getUserId)
	const countryCode = useSelector(getCountryCode)
	const upsell_test = params?.upsell_test || useSelector(getUpsellPrice)
	const initial_price = params?.initial_price || useSelector(getInitialPrice)

	const handleVote = flow => {
		if (+flow === 1) {
			ampSetUserProperty(
				'flow_type',
				'marry',
				user_id || params.user_id || window.id,
			)
			dispatch(setFlowType({ flow_type: '3' }))
			dispatch(setSecondFlow())
		} else {
			ampSetUserProperty(
				'flow_type',
				'baby',
				user_id || params.user_id || window.id,
			)
			dispatch(setFlowType({ flow_type: '4' }))
			dispatch(setThirdFlow())
		}

		setIsActive(false)
		ampEventWithEventProperty('Question_answered', { question: '1' })

		setTimeout(() => {
			history.push({
				pathname: '/question/1',
				search: isLegalFlow
					? paramsToQuery({ user_id, external_id: user_id })
					: paramsToQuery({
							user_id,
							external_id: user_id,
							upsell_test,
							initial_price,
					  }),
			})
		}, 350)
	}

	const handleFlowWithImage = e => {
		ampSetUserProperty(
			'flow_type',
			'upload_photo',
			user_id || params.user_id || window.id,
		)
		ampEventWithEventProperty('Question_answered', { question: '1' })

		const file = e.target.files[0]
		const URL = window.URL
		const imageURL = URL.createObjectURL(file)

		if (flow_tag === '33') {
			applyCartoonifyFilter(file, user_id)
			dispatch(setFlowType({ flow_type: '5' }))
			setIsActive(false)
			setTimeout(() => {
				history.push({
					pathname: '/processing',
					search: isLegalFlow
						? paramsToQuery({ user_id, external_id: user_id })
						: paramsToQuery({
								user_id,
								external_id: user_id,
								upsell_test,
								initial_price,
						  }),
				})
			}, 350)
		} else if (flow_tag === '55') {
			dispatch(setFlowType({ flow_type: '9' }))
			setIsActive(false)
			setTimeout(() => {
				history.push({
					pathname: '/features',
					search: isLegalFlow
						? paramsToQuery({ user_id, external_id: user_id })
						: paramsToQuery({
								user_id,
								external_id: user_id,
								upsell_test,
								initial_price,
						  }),
				})
			}, 350)
		} else {
			dispatch(setImage({ imageURL }))
			dispatch(setFlowType({ flow_type: '1' }))
			setIsActive(false)
			setTimeout(() => {
				history.push({
					pathname: '/features',
					search: isLegalFlow
						? paramsToQuery({ user_id, external_id: user_id })
						: paramsToQuery({
								user_id,
								external_id: user_id,
								upsell_test,
								initial_price,
						  }),
				})
			}, 350)
		}
	}

	const handleFlowWithoutImage = () => {
		if (flow_tag === '33') {
			dispatch(setFlowType({ flow_type: '6' }))
		} else if (flow_tag === '55') {
			dispatch(setFlowType({ flow_type: '10' }))
		} else {
			dispatch(setFlowType({ flow_type: '2' }))
		}

		ampSetUserProperty(
			'flow_type',
			'quiz',
			user_id || params.user_id || window.id,
		)
		ampEventWithEventProperty('Question_answered', { question: '1' })
		setIsActive(false)

		setTimeout(() => {
			history.push({
				pathname: '/question/1',
				search: isLegalFlow
					? paramsToQuery({ user_id, external_id: user_id })
					: paramsToQuery({
							user_id,
							external_id: user_id,
							upsell_test,
							initial_price,
					  }),
			})
		}, 350)
	}

	useEffect(() => {
		setIsUploadPhotoActive(true)
		setTimeout(() => {
			if (user_id && countryCode) {
				ampEvent('Onboarding_shown')
			}
		}, 0)
		setTimeout(() => {
			setIsActive(true)
		}, 700)
	}, [])

	return flow_tag === '22' ? (
		<div className={`prediction ${isActive ? 'prediction--active' : ''}`}>
			<h2 className="prediction__header">
				Choose your
				<span className="accent"> Prediction</span>
			</h2>
			<div className="prediction__voting">
				<VoteCard
					video="marry"
					text="When will I marry?"
					onSelect={() => handleVote(1)}
				/>
				<VoteCard
					video="baby"
					text="When will I have baby?"
					onSelect={() => handleVote(2)}
				/>
			</div>
		</div>
	) : (
		<div className={`home ${isActive ? 'home--active' : ''}`}>
			<input
				type="file"
				id="file-input"
				accept="image/*"
				onChange={e => handleFlowWithImage(e)}
			/>
			<Slider flow_tag={flow_tag} />
			<Rating flow_tag={flow_tag} />
			<ButtonControl
				isHomeScreen={true}
				buttonText="Upload a photo to start"
				skipText="I'll try later"
				onClickSkip={handleFlowWithoutImage}
				disabled={isUploadPhotoActive}
			/>
		</div>
	)
}

export { HomeScreen }
